@if (showLoader()) {
  <div class="fresh-loader fresh-loader--centered fresh-loader--lg">
    <svg viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle
        class="length"
        fill="none"
        stroke-width="4"
        stroke-linecap="round"
        cx="33"
        cy="33"
        r="28"></circle>
    </svg>
    <svg viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle
        fill="none"
        stroke-width="4"
        stroke-linecap="round"
        cx="33"
        cy="33"
        r="28"></circle>
    </svg>
    <svg viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle
        fill="none"
        stroke-width="4"
        stroke-linecap="round"
        cx="33"
        cy="33"
        r="28"></circle>
    </svg>
    <svg viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle
        fill="none"
        stroke-width="4"
        stroke-linecap="round"
        cx="33"
        cy="33"
        r="28"></circle>
    </svg>
  </div>
}
